import React from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../layout/index";
import { Users, Stethoscope, MessageSquare, FileText } from "lucide-react";

/**
 * CureBay Backoffice Dashboard
 * Dashboard for CureBay tenant - dummy placeholder
 */
const CurebayBackofficeDashboard = () => {
  const navigate = useNavigate();

  const statCards = [
    {
      title: "Total Doctors",
      value: "—",
      icon: Stethoscope,
      color: "bg-[#E0F2FE]",
      iconColor: "text-[#0284C7]",
      onClick: () => navigate("/CurebayDoctorList"),
    },
    {
      title: "Doctor Onboarding",
      value: "—",
      icon: FileText,
      color: "bg-[#D1FAE5]",
      iconColor: "text-[#059669]",
      onClick: () => navigate("/CurebayDoctorVerify"),
    },
    {
      title: "Patient Feedback",
      value: "—",
      icon: MessageSquare,
      color: "bg-[#FEF3C7]",
      iconColor: "text-[#D97706]",
      onClick: () => navigate("/CurebayPatientFeedback"),
    },
    {
      title: "Overview",
      value: "—",
      icon: Users,
      color: "bg-[#EDE9FE]",
      iconColor: "text-[#7C3AED]",
    },
  ];

  return (
    <DashboardLayout>
      <div className="p-4 md:p-6">
        <h1 className="text-2xl font-bold text-[#004276] mb-6">
          CureBay Backoffice Dashboard
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {statCards.map((card) => {
            const Icon = card.icon;
            return (
              <div
                key={card.title}
                onClick={card.onClick}
                className={`${card.color} p-6 rounded-xl shadow-sm ${
                  card.onClick ? "cursor-pointer hover:shadow-md transition-shadow" : ""
                }`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">
                      {card.title}
                    </p>
                    <p className="text-2xl font-bold text-[#004276] mt-1">
                      {card.value}
                    </p>
                  </div>
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center bg-white/60 ${card.iconColor}`}
                  >
                    <Icon size={24} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
          <h2 className="text-lg font-semibold text-[#004276] mb-4">
            Welcome to CureBay Backoffice
          </h2>
          <p className="text-gray-600">
            This is a placeholder dashboard for CureBay tenant. Quick links
            above will take you to Doctor Onboarding, Doctor List, and Patient
            Feedback.
          </p>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CurebayBackofficeDashboard;
